import { render, staticRenderFns } from "./BtnAtualizarFeriados.vue?vue&type=template&id=c3fa9564"
import script from "./BtnAtualizarFeriados.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarFeriados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports